









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { getCloseButtonSvg, preloadCloseButtonSvg } from './closeButtonSvg';

@Component
export default class CloseButtonPreviewIcon extends Vue {
  @Prop({ type: String, default: 'none' })
  bgMode!: 'none' | 'circle' | 'square';

  @Prop({ type: String, default: '#463C32' })
  iconColor!: string;

  @Prop({ type: String, default: 'rgba(0,0,0,0)' })
  bgColor!: string;

  @Prop({ type: Number, default: 18 })
  size!: number;

  svgContent = '';

  get wrapperStyle() {
    return {
      '--close-btn-bg': this.bgColor,
      '--close-btn-icon': this.iconColor,
      width: `${this.size}px`,
      height: `${this.size}px`,
    };
  }

  async created() {
    await preloadCloseButtonSvg();
    this.updateSvgContent();
  }

  @Watch('bgMode')
  onBgModeChange() {
    this.updateSvgContent();
  }

  updateSvgContent() {
    this.svgContent = getCloseButtonSvg(this.bgMode);
  }
}
